import ChangePasswordModal from './ChangePasswordModal';
export default ChangePasswordModal;


// WEBPACK FOOTER //
// ./src/components/App/Profile/UserInformation/ChangePasswordModal/index.js